var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.18,
    height: 23.199,
    viewBox: "0 0 21.18 23.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-2.25 -7.101)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51374",
    "data-name": "Path 51374",
    d: "M22.68,22.5v4.2a2.061,2.061,0,0,1-2.02,2.1H6.52A2.061,2.061,0,0,1,4.5,26.7V22.5",
    transform: "translate(-0.75)",
    fill: "none",
    stroke: "#5460d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51375",
    "data-name": "Path 51375",
    d: "M10.5,15l5.192,5.192L20.884,15",
    transform: "translate(-3 2)",
    fill: "none",
    stroke: "#5460d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51376",
    "data-name": "Path 51376",
    d: "M18,17.4V4.5",
    transform: "translate(-5.309 4.101)",
    fill: "none",
    stroke: "#5460d1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8fb31d1f0524051e5f55b54610d9a838.svg";
export { ForwardRef as ReactComponent };